/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_JwtInputs */

const en_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

const ar_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رموز JWT`)
};

const bn_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

const de_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

const es_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

const fr_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

const pt_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

const zh_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

const tr_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

const ru_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

const pl_svchip_jwt = /** @type {(inputs: Svchip_JwtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT`)
};

/**
* | output |
* | --- |
* | "JWT" |
*
* @param {Svchip_JwtInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_jwt = /** @type {((inputs?: Svchip_JwtInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_JwtInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_jwt(inputs)
	if (locale === "bn") return bn_svchip_jwt(inputs)
	if (locale === "de") return de_svchip_jwt(inputs)
	if (locale === "es") return es_svchip_jwt(inputs)
	if (locale === "fr") return fr_svchip_jwt(inputs)
	if (locale === "pt") return pt_svchip_jwt(inputs)
	if (locale === "zh") return zh_svchip_jwt(inputs)
	if (locale === "tr") return tr_svchip_jwt(inputs)
	if (locale === "ru") return ru_svchip_jwt(inputs)
	if (locale === "pl") return pl_svchip_jwt(inputs)
	return en_svchip_jwt(inputs)
});